export default __webpack_public_path__ + "static/media/LaptopIllu.b441dd77.svg";